import { Component, Inject, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { Api } from '../../services/api';
import { NgSelectModule } from '@ng-select/ng-select';
import { MDLCallRegister } from '../mdl-call-register/mdl-call-register';
import { MdlNewEventComponent } from '../mdl-new-event/mdl-new-event';
import { MDLModifyTask } from '../mdl-modify-task/mdl-modify-task';
import { AlertService } from '../../services/alert.service';
import {jwtDecode} from 'jwt-decode';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'app-mdl-new-task',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
  templateUrl: './mdl-new-task.html',
  styleUrls: ['./mdl-new-task.css'],
})
export class MdlNewTaskComponent implements OnInit {
  tiposTarea = [
    {
      valor: 'nueva_tarea',
      nombre: 'Nueva Tarea',
      icono: 'assets/svg/task-icon-orange.svg',
    },
    {
      valor: 'nuevo_evento',
      nombre: 'Nuevo Evento',
      icono: 'assets/svg/new-event-icon.svg',
    },
    {
      valor: 'nuevo_correo',
      nombre: 'Nuevo Correo',
      icono: 'assets/svg/new-email-icon.svg',
    },
    {
      valor: 'nueva_llamada',
      nombre: 'Nueva Llamada',
      icono: 'assets/svg/call-icon-orange.svg',
    },
  ];

  ejecutivos: any[] = [];
  relacionados: any[] = [];
  tipoRelacionado: string = '';
  elementosFiltrados: any[] = [];
  tipoTareaSeleccionado: string = '';
  currentStep: number = 1;
  showRepeatOptions: boolean = false;
  showReminderOptions: boolean = false;
  disabledSelect: boolean = false;
  currentUserId = '';
  CurrentUsername = '';
  canViewUsers = true;
  disableAssignSelect = false;

  taskData = {
    title: '',
    comment: '',
    status: '',
    assignedTo: '',
    dueDate: this.getTodayDate(),
    dueTime: '10:00',
    reminderEnabled: false,
    priority: 'Media',
    relatedTo: '',
    repeatTask: false,
    frecuencia: '',
    fechaInicio: this.getTodayDate(),
    fechaFin: this.getTodayDate(),
    horaInicio: '10:00',
    horaFin: '10:00',
    tiempoRecordatorio: '',
    telefono: '',
    tipoLlamada: '',
    resultado: '',
  };
 

  constructor(
  private api: Api,
  private permissionservice: PermissionService,
  private dialog: MatDialog,
  private alertService: AlertService,
  public dialogRef: MatDialogRef<MdlNewTaskComponent>,
  @Inject(MAT_DIALOG_DATA) public data: any
) {}

  ngOnInit() {
    if (this.data?.mode==='edit' && this.data.task){
      console.log(this.data.task)
      this.currentStep =2;
      this.tipoTareaSeleccionado = this.mapTipoFrontend(this.data.task.tipo);
      

      this.taskData = {
      title: this.data.task.titulo,
      comment: this.data.task.comentarios,
      status: this.data.task.estado,
      assignedTo: this.data.task.ejecutivo_id,
      dueDate: this.data.task.fecha_vencimiento,
      dueTime: this.data.task.hora_vencimiento,
      priority: this.mapPrioridadFrontend(this.data.task.prioridad),
      relatedTo: this.data.task.asociado_id,
      repeatTask: this.data.task.datos_adicionales?.repeatTask,
      frecuencia: this.data.task.datos_adicionales?.frecuencia,
      fechaInicio: this.data.task.datos_adicionales?.fechaInicio,
      fechaFin: this.data.task.datos_adicionales?.fechaFin,
      horaInicio: this.data.task.datos_adicionales?.horaInicio,
      horaFin: this.data.task.datos_adicionales?.horaFin,
      reminderEnabled: this.data.task.datos_adicionales?.reminderEnabled,
      tiempoRecordatorio: this.data.task.datos_adicionales?.tiempoRecordatorio,
      telefono: this.data.task.datos_adicionales?.telefono || '',
      tipoLlamada: this.data.task.datos_adicionales?.tipoLlamada || '',
      resultado: this.data.task.datos_adicionales?.resultado || '',
    };

    }

    if(this.data){
      if(this.data.mode === 'call'){
        this.tipoTareaSeleccionado = 'nueva_llamada';
        this.currentStep = this.data.step || 2;
        this.cargarEntidad(this.data.tipo);
      }else if(this.data.mode === 'task'){
        this.tipoTareaSeleccionado = 'nueva_tarea';
        this.currentStep = this.data.step || 2;
      }else if(this.data.mode === 'event'){
        this.tipoTareaSeleccionado = 'nuevo_evento';
        this.currentStep = this.data.step || 2;
      }
    }

    const token = localStorage.getItem('crmtoken');
    if (token) {
      const decoded: any = jwtDecode(token);
      this.currentUserId = decoded.usuario_id || decoded.userId || decoded.sub || '';
  this.CurrentUsername = decoded.nombre && decoded.apellido
    ? `${decoded.nombre} ${decoded.apellido}`
    : 'Yo';

    }

     this.canViewUsers = this.permissionservice.hasPermission('Usuarios y roles', 'Ver Usuarios');
    if (!this.canViewUsers) {
     this.disableAssignSelect = true;
     this.taskData.assignedTo = this.currentUserId;
     this.ejecutivos=[{
      valor: this.currentUserId,
      nombre: this.CurrentUsername,
      usuario: {}
    }];
  }else{
    this.cargarUsuarios();
  }


    
    this.cargarTodosLosRelacionados();
  }

mapTipoFrontend(tipo: string): string {
  const map: Record<string, string> = {
    Tarea: 'nueva_tarea',
    Llamada: 'nueva_llamada',
    Evento: 'nuevo_evento',
    Email: 'nuevo_correo',
  };

  return map[tipo] || 'nueva_tarea';
}
mapPrioridadFrontend(prioridad: string): string {
  const map: Record<string, string> = {
    baja: 'Baja',
    media: 'Media',
    alta: 'Alta',
  };

  return map[prioridad] || 'Media';
}

getTextoBotonCrear() {
  if (this.tipoTareaSeleccionado === 'nueva_llamada') return 'Registrar llamada';
  if (this.tipoTareaSeleccionado === 'nuevo_evento') return 'Registrar evento';
  return 'Crear nueva tarea';
}
  cargarEntidad(tipo: string){
    if(this.data && this.data.entidad){
      this.tipoRelacionado = tipo;
      this.taskData.relatedTo = this.data.entidad.prospecto_id;
      this.elementosFiltrados = [{
        valor: this.data.entidad.prospecto_id,
        nombre: `${this.data.entidad.nombre} ${this.data.entidad.apellido}`,
        tipo: 'PRO',
        icono: 'assets/svg/name-icon.svg',
        tipoDisplay: 'Prospecto',
      }];

       if (tipo === 'PRO') {
      this.disabledSelect = true;
    }

      console.log('Entidad precargada:', this.data.entidad);
    }
  }

 cargarTodosLosRelacionados() {
  console.log('🔄 Cargando todos los relacionados...');

  this.api.getContacts().subscribe({
    next: (response: any) => {
      const contactos = response.contactos || response || [];
      const contactosMapeados = contactos.map((contacto: any) => ({
        valor: contacto.contacto_id,
        nombre: `👤 ${contacto.nombre} ${contacto.apellido}`,
        tipo: 'CNT',
        icono: 'assets/svg/contact-icon.svg',
        tipoDisplay: 'Contacto',
      }));

      this.api.getAccounts().subscribe({
        next: (accountsResponse: any) => {
          const cuentas = accountsResponse.cuentas || accountsResponse || [];
          const cuentasMapeadas = cuentas.map((cuenta: any) => ({
            valor: cuenta.cuenta_id,
            nombre: `🏢 ${cuenta.nombre_empresa}`,
            tipo: 'ACC',
            icono: 'assets/svg/account-icon.svg',
            tipoDisplay: 'Cuenta',
          }));

          this.api.getOpportunities().subscribe({
            next: (oppResponse: any) => {
              const oportunidades = oppResponse.oportunidades || oppResponse || [];
              const oportunidadesMapeadas = oportunidades.map((opp: any) => ({
                valor: opp.oportunidad_id,
                nombre: `💼 ${opp.nombre}`,
                tipo: 'OPP',
                icono: 'assets/svg/opportunities-icon.svg',
                tipoDisplay: 'Oportunidad',
              }));

              // 👇 ahora también cargamos prospectos
              this.api.getProspects().subscribe({
                next: (prosResponse: any) => {
                  const prospectos = prosResponse.prospectos || prosResponse || [];
                  const prospectosMapeados = prospectos.map((pros: any) => ({
                    valor: pros.prospecto_id,
                    nombre: `${pros.nombre} ${pros.apellido}`,
                    tipo: 'PRO',
                    icono: 'assets/svg/name-icon.svg',
                    tipoDisplay: 'Prospecto',
                  }));

                  this.relacionados = [
                    ...contactosMapeados,
                    ...cuentasMapeadas,
                    ...oportunidadesMapeadas,
                    ...prospectosMapeados,
                  ];

                  console.log('✅ Todos los relacionados cargados:', this.relacionados.length);
                },
                error: (error) => {
                  console.error('❌ Error al cargar prospectos:', error);
                  this.relacionados = [
                    ...contactosMapeados,
                    ...cuentasMapeadas,
                    ...oportunidadesMapeadas,
                  ];
                }
              });
            },
            error: (error) => {
              console.error('❌ Error al cargar oportunidades:', error);
              this.combinarRelacionados(contactosMapeados, cuentasMapeadas, []);
            },
          });
        },
        error: (error) => {
          console.error('❌ Error al cargar cuentas:', error);
          this.combinarRelacionados(contactosMapeados, [], []);
        },
      });
    },
    error: (error) => {
      console.error('❌ Error al cargar contactos:', error);
      this.relacionados = [];
    },
  });
}


  getIconForTipoRelacionado(tipo: string): string {
    const iconos: { [key: string]: string } = {
      CNT: 'assets/svg/contact-icon.svg',
      ACC: 'assets/svg/account-icon.svg',
      OPP: 'assets/svg/opportunities-icon.svg',
      PRO: 'assets/svg/name-icon.svg'
    };
    return iconos[tipo] || 'assets/svg/search.svg';
  }

  combinarRelacionados(contactos: any[], cuentas: any[], oportunidades: any[]) {
    this.relacionados = [...contactos, ...cuentas, ...oportunidades];
    console.log('🔄 Relacionados combinados:', this.relacionados.length);
  }

  getTipoRelacionado(relatedTo: string): string {
    if (!relatedTo) return 'OTRO';

    const relacionado = this.relacionados.find((r) => r.valor === relatedTo);
    return relacionado ? relacionado.tipo : 'OTRO';
  }

  cargarUsuarios() {
    this.api.getUsers().subscribe({
      next: (response: any) => {
        console.log('🔍 Respuesta completa del backend:', response);

        let usuarios = [];

        if (Array.isArray(response)) {
          usuarios = response;
        } else if (response.users && Array.isArray(response.users)) {
          usuarios = response.users;
        } else if (response.usuarios && Array.isArray(response.usuarios)) {
          usuarios = response.usuarios;
        } else if (response.message && Array.isArray(response.data)) {
          usuarios = response.data;
        } else {
          console.warn('Estructura de respuesta no reconocida:', response);
          usuarios = [];
        }

        console.log('👥 Usuarios extraídos:', usuarios);

        this.ejecutivos = usuarios
          .filter(
            (usuario: any) =>
              usuario.activo === 1 || usuario.activo === undefined
          )
          .map((usuario: any) => ({
            valor: usuario.usuario_id,
            nombre: `${usuario.nombre} ${usuario.apellido}`,
            usuario: usuario,
          }));

        console.log(
          '✅ Usuarios procesados para el dropdown:',
          this.ejecutivos
        );

        if (this.ejecutivos.length > 0 && !this.taskData.assignedTo) {
          this.taskData.assignedTo = this.ejecutivos[0].valor;
          console.log(
            '🎯 Usuario por defecto asignado:',
            this.taskData.assignedTo
          );
        }


        if (this.ejecutivos.length === 0) {
          console.warn('⚠️ No se encontraron usuarios activos');
          this.usarUsuariosDePrueba();
        }
      },
      error: (error) => {
        console.error('❌ Error al cargar usuarios:', error);
        this.usarUsuariosDePrueba();
      },
    });
  }

  cargarContactos() {
    this.api.getContacts().subscribe({
      next: (response: any) => {
        console.log('📞 Contactos cargados:', response);

        const contactos = response.contactos || response || [];

        this.elementosFiltrados = contactos.map((contacto: any) => ({
          valor: contacto.contacto_id,
          nombre: `${contacto.nombre} ${contacto.apellido}`,
          tipo: 'CNT',
          icono: 'assets/svg/contact-icon.svg',
          tipoDisplay: 'Contacto',
        }));

        console.log(
          '✅ Contactos listos para selección:',
          this.elementosFiltrados.length
        );
      },
      error: (error) => {
        console.error('❌ Error al cargar contactos:', error);
        this.elementosFiltrados = [];
      },
    });
  }

  cargarCuentas() {
    this.api.getAccounts().subscribe({
      next: (response: any) => {
        console.log('🏢 Cuentas cargadas:', response);

        const cuentas = response.cuentas || response || [];

        this.elementosFiltrados = cuentas.map((cuenta: any) => ({
          valor: cuenta.cuenta_id,
          nombre: cuenta.nombre_empresa,
          tipo: 'ACC',
          icono: 'assets/svg/account-icon.svg',
          tipoDisplay: 'Cuenta',
        }));

        console.log(
          '✅ Cuentas listas para selección:',
          this.elementosFiltrados.length
        );
      },
      error: (error) => {
        console.error('❌ Error al cargar cuentas:', error);
        this.elementosFiltrados = [];
      },
    });
  }

  cargarOportunidades() {
    this.api.getOpportunities().subscribe({
      next: (response: any) => {
        console.log('💼 Oportunidades cargadas:', response);

        const oportunidades = response.oportunidades || response || [];

        this.elementosFiltrados = oportunidades.map((opp: any) => ({
          valor: opp.oportunidad_id,
          nombre: opp.nombre,
          tipo: 'OPP',
          icono: 'assets/svg/opportunities-icon.svg',
          tipoDisplay: 'Oportunidad',
        }));

        console.log(
          '✅ Oportunidades listas para selección:',
          this.elementosFiltrados.length
        );
      },
      error: (error) => {
        console.error('❌ Error al cargar oportunidades:', error);
        this.elementosFiltrados = [];
      },
    });
  }

  limpiarSeleccionRelacionado() {
    this.tipoRelacionado = '';
    this.taskData.relatedTo = '';
    this.elementosFiltrados = [];
    console.log('🧹 Selección de relación limpiada');
  }

  getPlaceholderPorTipo(): string {
    switch (this.tipoRelacionado) {
      case 'CNT':
        return 'Selecciona un contacto...';
      case 'ACC':
        return 'Selecciona una cuenta...';
      case 'OPP':
        return 'Selecciona una oportunidad...';
      case 'PRO':
        return 'Selecciona un prospecto...'
      default:
        return 'Buscar...';
    }
  }

  getTipoDisplay(): string {
    switch (this.tipoRelacionado) {
      case 'CNT':
        return 'contactos';
      case 'ACC':
        return 'cuentas';
      case 'OPP':
        return 'oportunidades';
      case 'PRO':
        return 'prospectos';
      default:
        return 'elementos';
    }
  }

  onTipoRelacionadoChange() {
    console.log('🔍 Tipo de relación seleccionado:', this.tipoRelacionado);

    this.taskData.relatedTo = '';
    this.elementosFiltrados = [];

  
    this.disabledSelect = false;
  
    if (this.tipoRelacionado && this.tipoRelacionado !== 'OTRO') {
      this.cargarElementosPorTipo(this.tipoRelacionado);
    } else {
      this.elementosFiltrados = [];
    }
  }

  cargarElementosPorTipo(tipo: string) {
    console.log('🔄 Cargando elementos para tipo:', tipo);

    switch (tipo) {
      case 'CNT':
        this.cargarContactos();
        break;
      case 'ACC':
        this.cargarCuentas();
        break;
      case 'OPP':
        this.cargarOportunidades();
        break;
      case 'PRO':
        this.cargarProspectos();
        break  
      default:
        this.elementosFiltrados = [];
    }
  }

  usarUsuariosDePrueba() {
    this.api.getUsers().subscribe({
      next: (response: any) => {
        console.log('🔍 Respuesta completa del backend:', response);
        let usuarios = [];
        usuarios = response.users || [];
        console.log('👥 Usuarios extraídos:', usuarios)
        this.ejecutivos = usuarios
          .filter((usuario: any) => usuario.activo === 0 || usuario.activo === undefined)
          .map((usuario: any) => ({ 
            valor: usuario.usuario_id,
            nombre: `${usuario.nombre} ${usuario.apellido}`,
            usuario: usuario
          }));
        console.log('✅ Usuarios procesados para el dropdown:', this.ejecutivos);
      },
      error: (error) => {
        console.error('❌ Error al cargar usuarios:', error);
        console.warn('⚠️ Usando usuarios de prueba');
      }
    });
  }

  getIconForTipo(tipo: string): string {
    const tarea = this.tiposTarea.find((t) => t.valor === tipo);
    return tarea ? tarea.icono : 'assets/svg/task-icon-orange.svg';
  }

  getTipoNombre(): string {
    const tarea = this.tiposTarea.find(
      (t) => t.valor === this.tipoTareaSeleccionado
    );
    return tarea ? tarea.nombre : 'Tarea';
  }

  getTodayDate(): string {
    return new Date().toISOString().split('T')[0];
  }

  closeMdl() {
    this.tipoRelacionado = '';
    this.relacionados = [];
    this.taskData.relatedTo = '';
    this.dialogRef.close(false);
  }

  siguiente() {
    if (!this.tipoTareaSeleccionado) {
      console.log('Por favor selecciona un tipo de tarea');
      return;
    }

    console.log('Tipo de tarea seleccionado:', this.tipoTareaSeleccionado);

    switch (this.tipoTareaSeleccionado) {
      case 'nuevo_evento':
        this.abrirModalEvento();
        break;
      case 'nueva_llamada':
      case 'nueva_tarea':
        this.currentStep = 2;
        break;
      default:
        this.currentStep = 2;
    }
  }

  abrirModalEvento() {
    this.dialogRef.close();

    const dialogRef = this.dialog.open(MdlNewEventComponent, {
      width: '800px',
      height: 'auto',
      maxHeight: '90vh',
      panelClass: 'modal-container',
      autoFocus: false,
      data: {},
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Modal de evento cerrado:', result);
      if (result && result.success) {
      }
    });
  }

  previousStep() {
    this.currentStep = 1;
  }

  onTipoTareaChange() {
    console.log('Tipo de tarea cambiado a:', this.tipoTareaSeleccionado);

    if (this.tipoTareaSeleccionado === 'nueva_llamada') {
      this.taskData.status = 'pendiente';
    } else if (this.tipoTareaSeleccionado === 'nueva_tarea') {
      this.taskData.status = 'pendiente';
    } else if (this.tipoTareaSeleccionado === 'nuevo_evento') {
      this.taskData.status = 'pendiente';
    } else {
      this.taskData.status = '';
    }

    if (this.tipoTareaSeleccionado !== 'nueva_llamada') {
      this.taskData.telefono = '';
      this.taskData.tipoLlamada = '';
      this.taskData.resultado = '';
    }
  }

  onRepeatTaskChange() {
    this.showRepeatOptions = this.taskData.repeatTask;
    console.log(
      'Repeat Task:',
      this.taskData.repeatTask,
      'Show Options:',
      this.showRepeatOptions
    );
  }

  onReminderEnabledChange() {
    this.showReminderOptions = this.taskData.reminderEnabled;
    console.log(
      'Reminder Enabled:',
      this.taskData.reminderEnabled,
      'Show Options:',
      this.showReminderOptions
    );
  }

  crearTarea() {
    if (this.tipoTareaSeleccionado === 'nueva_tarea' && !this.taskData.title) {
      console.log('El título es requerido');
      alert('Por favor ingresa un título para la tarea');
      return;
    }

    if (
      this.tipoTareaSeleccionado === 'nueva_llamada' &&
      !this.taskData.title
    ) {
      console.log('El asunto es requerido');
      alert('Por favor ingresa un asunto para la llamada');
      return;
    }

    if (!this.taskData.status) {
      const mensaje =
        this.tipoTareaSeleccionado === 'nueva_llamada'
          ? 'Por favor selecciona el estado de la llamada'
          : 'Por favor selecciona el estado de la tarea';
      alert(mensaje);
      return;
    }

    if (!this.canViewUsers && !this.taskData.assignedTo) {
      this.taskData.assignedTo = this.currentUserId;
    }

    if (!this.taskData.assignedTo) {
      const mensaje =
        this.tipoTareaSeleccionado === 'nueva_llamada'
          ? 'Por favor asigna la llamada a un usuario'
          : 'Por favor asigna la tarea a un usuario';
      alert(mensaje);
      return;
    }

    if (!this.taskData.priority) {
      const mensaje =
        this.tipoTareaSeleccionado === 'nueva_llamada'
          ? 'Por favor selecciona la prioridad de la llamada'
          : 'Por favor selecciona la prioridad de la tarea';
      alert(mensaje);
      return;
    }

    if (!this.taskData.dueDate) {
      const mensaje =
        this.tipoTareaSeleccionado === 'nueva_llamada'
          ? 'Por favor selecciona la fecha programada'
          : 'Por favor selecciona la fecha de vencimiento';
      alert(mensaje);
      return;
    }

    if (!this.taskData.dueTime) {
      const mensaje =
        this.tipoTareaSeleccionado === 'nueva_llamada'
          ? 'Por favor selecciona la hora programada'
          : 'Por favor selecciona la hora de vencimiento';
      alert(mensaje);
      return;
    }

    if (this.taskData.repeatTask) {
      if (!this.taskData.fechaInicio || !this.taskData.fechaFin) {
        const mensaje =
          this.tipoTareaSeleccionado === 'nueva_llamada'
            ? 'Por favor ingresa ambas fechas (inicio y fin) para la llamada recurrente'
            : 'Por favor ingresa ambas fechas (inicio y fin) para la tarea recurrente';
        alert(mensaje);
        return;
      }

      const fechaInicio = new Date(this.taskData.fechaInicio);
      const fechaFin = new Date(this.taskData.fechaFin);

      if (fechaInicio > fechaFin) {
        alert('La fecha de inicio no puede ser mayor que la fecha fin');
        return;
      }
    }

    let asociadoTipoFinal = 'OTRO';
    let asociadoIdFinal = '00000000-0000-0000-0000-000000000000';

    if (
      this.taskData.relatedTo &&
      this.tipoRelacionado &&
      this.tipoRelacionado !== 'OTRO'
    ) {
      asociadoTipoFinal = this.tipoRelacionado;
      asociadoIdFinal = this.taskData.relatedTo;

      console.log('🔗 Relación establecida:', {
        tipo: asociadoTipoFinal,
        id: asociadoIdFinal,
        nombre: this.elementosFiltrados.find(
          (r) => r.valor === this.taskData.relatedTo
        )?.nombre,
      });
    } else {
      console.log('🔗 Sin relación específica, usando valores por defecto');
    }

    const payload = {
      titulo: this.taskData.title,
      tipo: this.mapearTipoParaBackend(this.tipoTareaSeleccionado),
      fecha_vencimiento: this.taskData.dueDate,
      hora_vencimiento: this.taskData.dueTime,
      estado: this.mapearEstadoParaBackend(this.taskData.status),
      prioridad: this.mapearPrioridadParaBackend(this.taskData.priority),
      asociado_tipo: asociadoTipoFinal,
      asociado_id: asociadoIdFinal,
      ejecutivo_id: this.taskData.assignedTo,
      comentarios: this.taskData.comment || '',
      datos_adicionales: {
        repeatTask: this.taskData.repeatTask,
        frecuencia: this.taskData.frecuencia,
        fechaInicio: this.taskData.fechaInicio,
        fechaFin: this.taskData.fechaFin,
        horaInicio: this.taskData.horaInicio,
        horaFin: this.taskData.horaFin,
        reminderEnabled: this.taskData.reminderEnabled,
        tiempoRecordatorio: this.taskData.tiempoRecordatorio,
        ...(this.tipoTareaSeleccionado === 'nueva_llamada' && {
          telefono: this.taskData.telefono,
          tipoLlamada: this.taskData.tipoLlamada,
          resultado: this.taskData.resultado,
        }),
      },
    };

    console.log('📤 Enviando datos al backend:', payload);

this.api.createTarea(payload).subscribe({
  next: (response: any) => {
    console.log('✅ Registro creado exitosamente:', response);

    const tareaId =
      response?.tarea?.tarea_id ||
      response?.tarea_id ||
      response?.id;

    if (
      this.taskData.reminderEnabled &&
      this.taskData.tiempoRecordatorio &&
      tareaId
    ) {
      const fechaRecordatorio = this.calcularFechaRecordatorio(
        this.taskData.dueDate,
        this.taskData.dueTime,
        this.taskData.tiempoRecordatorio
      );

      if (fechaRecordatorio) {
        const recordatorioPayload = {
          tarea_id: tareaId,
          // recordatorio para el usuario asignado a la tarea
          usuario_id: this.taskData.assignedTo,
          fecha_recordatorio: fechaRecordatorio,
          visto: 0,
        };

        console.log('📤 Creando recordatorio:', recordatorioPayload);

        this.api.createRecordatorio(recordatorioPayload).subscribe({
          next: (r) => {
            console.log('✅ Recordatorio creado:', r);
          },
          error: (err) => {
            this.api.hideLoading();
            if(err?.status===403){
              this.alertService.error('Acceso denegado','No tienes permiso para crear tareas')
              this.dialogRef.close(false)
              return
            }
            this.alertService.error('Error','Ocurrió un problema al crear la tarea')
          },
        });
      }
    }

    const mensaje =
      this.tipoTareaSeleccionado === 'nueva_llamada'
        ? 'Llamada registrada correctamente'
        : 'Tarea creada correctamente';
    alert(mensaje);
    this.dialogRef.close({
      success: true,
      data: response,
    });
  },
      error: (error) => {
        console.error('❌ Error creando registro:', error);
        console.error('🔍 Detalles del error:', error.error);

        if (error.error && error.error.message) {
          alert(`Error: ${error.error.message}`);
        } else {
          const mensaje =
            this.tipoTareaSeleccionado === 'nueva_llamada'
              ? 'Error al registrar la llamada. Por favor intenta nuevamente.'
              : 'Error al crear la tarea. Por favor intenta nuevamente.';
          alert(mensaje);
        }
      },
    });
  }


  actualizarTarea(){
    const payload={
        tarea_id: this.data.task.tarea_id,
    titulo: this.taskData.title,
    tipo: this.mapearTipoParaBackend(this.tipoTareaSeleccionado),
    fecha_vencimiento: this.taskData.dueDate,
    hora_vencimiento: this.taskData.dueTime,
    estado: this.mapearEstadoParaBackend(this.taskData.status),
    prioridad: this.taskData.priority.toLowerCase(),
    asociado_tipo: this.tipoRelacionado,
    asociado_id: this.taskData.relatedTo,
    ejecutivo_id: this.taskData.assignedTo,
    comentarios: this.taskData.comment,
    datos_adicionales: this.taskData,
    }

    this.api.updateTarea(payload).subscribe({
      next:(r: any)=>{
      this.alertService.success('Tarea actualizada', 'Los cambios han sido guardados.');
      this.dialogRef.close(true);
      },
      error:(err)=>{
        this.alertService.error('Error', 'No se pudo actualizar la tarea');
      }
    })
  }
  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  mapearTipoParaBackend(tipo: string): string {
    const mapeo: { [key: string]: string } = {
      nueva_tarea: 'Tarea',
      nuevo_evento: 'Evento',
      nuevo_correo: 'Email',
      nueva_llamada: 'Llamada',
      modificar_tarea: 'Modificar',
    };
    return mapeo[tipo] || 'Tarea';
  }

  mapearEstadoParaBackend(estado: string): string {
    const mapeoTareas: { [key: string]: string } = {
      pendiente: 'pendiente',
      en_progreso: 'en_progreso',
      vencida: 'vencida',
      completada: 'completada',
    };

    const mapeoLlamadas: { [key: string]: string } = {
      pendiente: 'pendiente',
      vencida: 'vencida',
      completada: 'completada',
    };

    const mapeoEventos: { [key: string]: string } = {
      pendiente: 'pendiente',
      en_progreso: 'en_progreso',
      vencida: 'vencida',
      completada: 'completada',
    };

    if (this.tipoTareaSeleccionado === 'nueva_llamada') {
      return mapeoLlamadas[estado] || 'pendiente';
    } else if (this.tipoTareaSeleccionado === 'nuevo_evento') {
      return mapeoEventos[estado] || 'pendiente';
    } else {
      return mapeoTareas[estado] || 'pendiente';
    }
  }

  mapearPrioridadParaBackend(prioridad: string): string {
    const mapeo: { [key: string]: string } = {
      Baja: 'baja',
      Media: 'media',
      Alta: 'alta',
    };
    return mapeo[prioridad] || 'media';
  }

  resetForm() {
    this.tipoTareaSeleccionado = '';
    this.currentStep = 1;
    this.showRepeatOptions = false;
    this.showReminderOptions = false;

    this.taskData = {
      title: '',
      comment: '',
      status: '',
      assignedTo: '',
      dueDate: this.getTodayDate(),
      dueTime: '10:00',
      reminderEnabled: false,
      priority: 'Media',
      relatedTo: '',
      repeatTask: false,
      frecuencia: '',
      fechaInicio: this.getTodayDate(),
      fechaFin: this.getTodayDate(),
      horaInicio: '10:00',
      horaFin: '10:00',
      tiempoRecordatorio: '',
      telefono: '',
      tipoLlamada: '',
      resultado: '',
    };
  }

  private calcularFechaRecordatorio(
  fechaBase: string,
  horaBase: string,
  tiempoRecordatorio: string
): string | null {
  if (!fechaBase || !horaBase || !tiempoRecordatorio) return null;

  const base = new Date(`${fechaBase}T${horaBase}`);

  const mapaMinutos: { [key: string]: number } = {
    '5min': 5,
    '15min': 15,
    '30min': 30,
    '1h': 60,
    '1d': 60 * 24,
    '2d': 60 * 24 * 2,
  };

  const minutos = mapaMinutos[tiempoRecordatorio];
  if (!minutos) return null; 
  base.setMinutes(base.getMinutes() - minutos);

  return base.toISOString();
}

cargarProspectos() {
  console.log('📋 Cargando prospectos...');
  this.api.getProspects().subscribe({
    next: (response: any) => {
      console.log('📋 Prospectos cargados:', response);

      const prospectos = response.prospectos || response || [];

      this.elementosFiltrados = prospectos.map((prospecto: any) => ({
        valor: prospecto.prospecto_id,
        nombre: `${prospecto.nombre} ${prospecto.apellido}`,
        tipo: 'PRO',
        icono: 'assets/svg/name-icon.svg',
        tipoDisplay: 'Prospecto',
      }));

      console.log(
        '✅ Prospectos listos para selección:',
        this.elementosFiltrados.length
      );
    },
    error: (error) => {
      console.error('❌ Error al cargar prospectos:', error);
      this.elementosFiltrados = [];
    },
  });
}


}
